import { Button, Spinner } from "react-bootstrap";

const ButtonWithSpinner = ({ className, children, disabled, loading, onClick, size, type, variant }) => (
	<Button className={className} disabled={loading || disabled} onClick={onClick} size={size} type={type} variant={variant}>
		{loading ? <Spinner animation="border" size="sm" /> : children}
	</Button>
);

export default ButtonWithSpinner;